<template>
	<div class="insightBox">
		<div class="leftChildNav" :class="showLeft ? '' : 'hide'">
			<el-menu :default-active="activeMenu" active-text-color="#fff" router class="el-menu-vertical-demo"
				@close="handleClose">
				<el-submenu v-for="(item, index) in route[activeR]" :key="index" :index="item.resourceName">
					<template slot="title">
						<img :src="item.icon" style="margin-right: 20px;" alt="">
						<span class="menu-label">
							{{ item.resourceName }}
							<span class="menu-badge" v-if="getNum(item.resourceName) > 0">{{ getNum(item.resourceName) }}</span>
						</span>
					</template>
					<el-menu-item v-for="(item1, index1) in item.children" :index="item1.resourceUrl" :key="index1">{{
						item1.resourceName
					}}
						<span class="menu-badge" v-if="getSumNum(item1) > 0">{{ getSumNum(item1) }}</span>
					</el-menu-item>
				</el-submenu>
			</el-menu>

		</div>
		<div class="rightContent">
			<div class="openNav" style="top: 80px;">
				<i class="el-icon-s-fold " style="font-size: 20px; color: #999;" v-if="showLeft" @click="goBack"></i>
			</div>
			<div class="closeNav" style="top:  80px;">
				<i class="el-icon-s-fold " style="font-size: 20px; color: #999;" v-if="!showLeft" @click="goBack"></i>
			</div>
			<img class="openNav" v-if="showLeft" src="../assets/image/shouqi.png" @click="changeState({
				prop: 'showLeft',
				value: false
			})" />
			<img class="closeNav" v-if="!showLeft" @click="changeState({
				prop: 'showLeft',
				value: true
			})" src="../assets/image/zhankai.png" />

			<keep-alive include="taskDetail">
				<router-view />
			</keep-alive>
		</div>
	</div>
</template>

<script>
import {
	mapState,
	mapMutations
} from 'vuex'
import { getUnreadCountSingle, getUnreadCountBatch, currentUser } from '@/api/public'

export default {
	name: 'home',
	data() {
		return {
			routerChildren: [],
			SingleNum: 0,
			BatchNum: 0,
			activeR: 'Pledge',
			title: {
				Pledge: '房屋智能估价',
				Analysis: '一键看项目',
			},
			route: {
				Pledge: [

				],
				Analysis: [{
					path: '/Empowerment/Analysis/Home',
					icon: 'iconfont icon-shouye',
					title: '首页'
				},

				],
			}
		};
	},
	computed: {
		...mapState(['showLeft', "fixedLeft"]),
		activeMenu() {
			let route = this.$route;
			let path = route.path;
			let meta = route.meta;
			if (meta && meta.from) {
				path = meta.from;
			}
			return path;
		},
		openName() {
			const route = this.$route;
			// const title = route.meta.title;
			const routerList = [route.meta.fName]
			return routerList;

		},

	},
	watch: {
		$route(to, from) {
			this.changeLeft(to);
			if (from.path === '/Empowerment/pledge/pledgeManage/taskManageNew') {
				to.meta.keepAlive = false;
			} else {
				to.meta.keepAlive = true;
			}
			this.getUnreadCountNum();
		},
	},
	methods: {
		...mapMutations(['changeState', 'changeFixed']),
		async getRouterList() {
			let routerList = [
				{
					path: '',
					title: '单套',
					icon: require('../assets/image/dantao.png'),
					children: [

						{
							path: '/Empowerment/pledge/houseProperty/rapidValuation',
							title: '我要估价'
						},
						{
							path: '/Empowerment/pledge/houseProperty/recordValuation',
							title: '历史记录'
						},
					]
				},

				{
					path: '',
					title: '批量',
					icon: require('../assets/image/piliang.png'),

					children: [
						{
							path: '/Empowerment/pledge/pledgeManage/taskManageNew',
							title: '我要估价'
						},
						{
							path: '/Empowerment/pledge/pledgeManage/taskRecord',
							title: '历史记录'
						},
					]
				}
			]
			// routerList = res.menu.find(item => item.resourceName === 'AI估价');
			let menuList = localStorage.getItem('menuList') ? JSON.parse(localStorage.getItem('menuList')) : [];
			const aiValuation = menuList.find(item => item.resourceName === 'AI估价');
			if (aiValuation && Array.isArray(aiValuation.children)) {
				routerList = aiValuation.children;
			}
			if (routerList && Array.isArray(routerList)) {
				routerList.sort((a, b) => {
					return (a.sort || 0) - (b.sort || 0);
				});
			}
			function filterTypeOne(list) {
				return (list || []).reduce((acc, item) => {
					if (item.type === '1') {
						const newItem = { ...item };
						if (Array.isArray(item.children)) {
							newItem.children = filterTypeOne(item.children);
						}
						acc.push(newItem);
					} else if (Array.isArray(item.children)) {
						// 如果当前节点type不是1，但是有children可能有type为1的子节点
						const filteredChildren = filterTypeOne(item.children);
						if (filteredChildren.length) {
							const newItem = { ...item, children: filteredChildren };
							acc.push(newItem);
						}
					}
					return acc;
				}, []);
			}
			routerList = filterTypeOne(routerList);
			this.route.Pledge = routerList;
			console.log('this.$router', this.$router.getRoutes())
		},
		selectRouter(data) {
			if (this.$route.path === data) return;
			if (data.indexOf('noPage') > -1) {
				return
			}
			this.$router.push(data).catch(err => err);
		},
		goBack() {
			this.$router.go(-1);
		},

		getNum(title) {
			// return 1;
			if (title == '单套') {
				return this.SingleNum;
			} else if (title == '批量') {
				return this.BatchNum;
			}
		},
		getSumNum(item) {
			// return 200;

			console.log('item', item)
			if (item.resourceName == '历史记录' && item.resourceUrl == '/Empowerment/pledge/houseProperty/recordValuation') {
				return this.SingleNum;
			} else if (item.resourceName == '我要估价' && item.resourceUrl == '/Empowerment/pledge/pledgeManage/taskManageNew') {
				return this.BatchNum;
			}
		},
		getUnreadCountNum() {
			// :0-单 1-任务批量
			let params = {
				// type: 0,

			}
			let params1 = {
				// type: 1,

			}
			getUnreadCountSingle(params).then(res => {
				console.log('res单套数量', res)
				this.SingleNum = res;
			})
			getUnreadCountBatch(params1).then(res => {
				console.log('res任务批量数量', res)
				this.BatchNum = res;
			})
		},
		subMenuClick(arr) {
			// if (arr.length) {
			// 	const data = arr.pop().replace('submenu', '')
			// 	data && this.$router.push(data);
			// }
		},
		changeLeft(router) {
			// 用path来判断属于哪个二级路由
			if (router.path.indexOf('/Empowerment/pledge/') > -1) {
				this.activeR = 'Pledge';
			} else if (router.path.indexOf('/Empowerment/Analysis/') > -1) {
				this.activeR = 'Analysis';
			}
		}
	},
	created() {
		this.getRouterList();
	},
	mounted() {
		this.getRouterList();

		this.changeLeft(this.$route);
		this.getUnreadCountNum();

		// this.$store.dispatch('initPublicData');
	}
};
</script>
<style lang="scss" scoped>
.menu-label {
	position: relative;
	display: inline-block;
}

.menu-badge {
	position: absolute;
	left: 64%;
	top: 10px;
	transform: translateX(6px);

	display: inline-flex;
	align-items: center;
	justify-content: center;

	min-width: 18px;
	height: 18px;
	padding: 0 6px;
	border-radius: 999px;

	background: #F56C6C;
	color: #fff;
	font-size: 12px;
	font-weight: 600;
	line-height: 18px;
	white-space: nowrap;
}

/* 菜单项右侧的 badge：用相对定位的菜单项本身来定位 */
::v-deep .el-menu-item {
	position: relative;
}

::v-deep .el-menu-item .menu-badge {
	position: absolute;
	// right: 14px;
	margin-left: -6px;
	top: 30%;
	left: auto;
	transform: translateY(-50%);
}

::v-deep .el-menu-item.is-active {
	// color: #fff;
	background: #045AFC;
	width: 90%;
	margin: auto;
	text-align: center;
	border-radius: 8px;

}

::v-deep .el-menu-item:focus,
.el-menu-item:hover {
	// background: #045AFC;
	width: 90%;
	margin: auto;
	border-radius: 8px;


}

@import "@/style/common.scss";

@import "@/assets/css/common.scss";

::v-deep .el-menu-item {
	transform: none !important;
	text-align: center;
	transition: none !important;
	-webkit-transition: none !important;
	/* 兼容旧版浏览器 */
}
</style>
